// 配置 element-ui 按需引入的组件

import { Button, Input, Form, FormItem, Message,} from 'element-ui'

Message.install = function (Vue, options) {
    Vue.prototype.$message = Message
}

const element = {
  install: function (Vue) {
    Vue.use(Button)
    Vue.use(Input)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Message)
  }
}
export default element


// WEBPACK FOOTER //
// ./src/assets/css/element/index.js